module.exports = __webpack_public_path__ + "static/media/microsoft.b06ede75.png";